import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Table, Loader} from 'semantic-ui-react';
import {parseWarrantiesFileData, validateExcelFields} from '../../utils';
import {Actions} from '../../../common/actions';
import ExcelReader from '../../../excelReader/components/index';
import WarrantyInsertTable from './warrantyInsertTable';
import ConfirmationModal from './modal/ConfirmationModal';
import './styles.scss';

class ExcelWarrantyInsert extends Component {
  componentWillUnmount() {
    this.props.clearWarrantyExcelList();
  }

  readExcelFile = (data) => {
    const warrantyData = data.slice(1);
    const loadedWarrantyExcel = parseWarrantiesFileData(warrantyData);
    const {error, message} = validateExcelFields(loadedWarrantyExcel);
    if (error) {
      this.props.addMessageBoxError(message);
    } else {
      this.props.processWarrantyExcelList(loadedWarrantyExcel);
    }
    this.props.loadingExcel(false);
  };

  cleanWarrantyExcel = () => {
    this.props.clearWarrantyExcelList();
  };

  renderLoader() {
    return (
      <Table striped className="toyota-grid">
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan="100%">
              <Loader active inline="centered" content="Cargando información" />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  validateWarranties = (list) => {
    let error = false;
    list.forEach((item) => {
      const keys = Object.keys(item).filter((element) => element.includes('Error'));
      const isError = keys.find((key) => item[key]);
      if (isError) {
        error = true;
        return error;
      }
    });
    return error;
  }

  render() {
    const {loadingExcelFile, loading, list, created} = this.props;
    const validateRecords = this.validateWarranties(list);

    return (
      <div className="warranty-excel">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Ingreso de Garantías Excel</h2>
              <div className="title-bar-actions">
                <Button secondary onClick={this.cleanWarrantyExcel}>
                  LIMPIAR
                </Button>
                <ExcelReader
                  saving={loadingExcelFile || loading}
                  text="CARGAR"
                  onGetFile={this.readExcelFile}
                />
                <ConfirmationModal
                  disabled={!list.length || validateRecords || created}
                  addWarrantyExcel={this.addWarrantyExcel}
                  warrantiesTotal={list.length}
                  list={list}
                />
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className="excel-table">
          {loadingExcelFile || loading ? (
            this.renderLoader()
          ) : (
            <WarrantyInsertTable dataTable={list} />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loadingExcelFile': state.excelReader.loading,
    'list': state.ExcelWarranty.list,
    'loading': state.ExcelWarranty.loading,
    'created': state.ExcelWarranty.created,
  };
};

const {
  withRouter,
  navigateTo,
  loadingExcel,
  processWarrantyExcelList,
  addMessageBoxError,
  clearWarrantyExcelList,
  addWarrantyExcelList,
} = Actions;

const mapDispatchToProps = {
  navigateTo,
  loadingExcel,
  processWarrantyExcelList,
  addMessageBoxError,
  clearWarrantyExcelList,
  addWarrantyExcelList,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ExcelWarrantyInsert)
);
